export const VIEW_PAGE_TRANSLATOR_FEATURE = "view_page_translator";
